import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useEffect, useState} from 'react';
import CustomPagination from '../../../../../components/table/CustomPagination';
import {GetAllEmployee} from '../../../../../reduxToolkit/EmployeeOnBoarding/EmployeeOnBoardingApi';
import {
    GetAllDriverRelationship, GetListOfVehicleImages,
    GetVehicleById,
    PremmissionType
} from '../../../../../reduxToolkit/Vehicle/VehicleApi';
import {SIMPLE_PAGINATION_MODEL} from "../../../../../components/table/Model/TableModel";
import {permissionObj} from "../../../../../Helpers/permission";

const EmployeeVehicleDetailApp = () => {

    // use hook
    const dispatch = useDispatch();
    const { id } = useParams();
    const { t } = useTranslation();
    // useState
    const [showModal, setShowModal] = useState(false);
    const [isDriverAdd, setIsDriverAdd] = useState('');
    const [updateDriverId, setUpdateDriverId] = useState('');
    const [driverNameUpdate, setDriverNameUpdate] = useState('');
    const [previousPath, setPreviousPath] = useState();
    const {
        getAllDriverRelationship,
        getListOfVehicleImages,
        getVehicleById,
        addDriver,
        removeDriverEmployee,
        updateDriver,
        updateVehicleV1,
    } = useSelector((state) => state.VehicleSlice);
    const { deleteDocumentById} = useSelector((state) => state.documentPanelSlice);
    const { uploadImage } = useSelector((state) => state.sharedSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    // Managing drivers modifies the vehicle, read only users just see the details
    const canUpdate = DEV || permission?.includes(permissionObj?.WEB_VEHICLE_UPDATE);
    // The driver detail opens the employee view, which requires its own module permission
    const canSeeDriverDetails = DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE);

    const { pagination, page, rowsPerPage } = CustomPagination({
        fixed:false,
        content:getListOfVehicleImages,
        labelRowsPerPage:'images_per_page'
    });

    useEffect(() => {
        setPreviousPath(sessionStorage.getItem('previousPath'));
    }, []);

    /**
     * Fetch data of employees and permission type
     */
    useEffect(() => {
        dispatch(GetAllEmployee());
        dispatch(PremmissionType());
    }, [updateVehicleV1]);


    /**
     *Fetch vehicle information by ID
     */
    useEffect(() => {
        if(id)
            dispatch(GetVehicleById(id));
    }, [id]);

    /**
     * Fetch data of vehicle drivers
     */
    useEffect(() => {
        if(id)
            dispatch(GetAllDriverRelationship(id));
    }, [addDriver, removeDriverEmployee, updateDriver]);

    /**
     *Fetch vehicle list with associated images
     */
    useEffect(() => {
        const data = {
            pagination: SIMPLE_PAGINATION_MODEL.set({ page, rowsPerPage }),
            vehicleId: id,
        };

        dispatch(GetListOfVehicleImages(data));
    }, [page, rowsPerPage, deleteDocumentById, uploadImage]);

    return {
        id, t,
        showModal, setShowModal,
        isDriverAdd, setIsDriverAdd,
        setUpdateDriverId,
        driverNameUpdate, setDriverNameUpdate,
        pagination,
        getAllDriverRelationship,
        getListOfVehicleImages,
        getVehicleById,
        updateDriver,
        canUpdate,
        canSeeDriverDetails,
    }

}

export default EmployeeVehicleDetailApp;
